module.exports = __webpack_public_path__ + "static/media/logo.a3c64e08.png";